import { prepareHtml } from 'core/common/utils/prepareHtml';
import { ContainerStyled } from './styled';

type PolicyProps = {
  content: string;
  className?: string;
};

export const Policy = ({ content, className }: PolicyProps) => {
  return (
    <ContainerStyled
      className={className}
      dangerouslySetInnerHTML={prepareHtml(content)}
    ></ContainerStyled>
  );
};
